// src/services/languageService.js
import apiClient from "./apiClient";

const endpoints = { base: "/admin/language" };

// Some backends only accept "Publish" | "Unpublish" (lowercase p);
// normalize anything we get from the UI.
const normalizeStatus = (s) => {
  const t = String(s || "").toLowerCase();
  return t === "publish" ? "Publish" : "Unpublish";
};

// GET: /admin/language
export async function getAllLanguages({ signal } = {}) {
  const res = await apiClient.get(endpoints.base, { signal });
  return res.data; // { statusCode, success, message, data:[...] }
}

// POST: /admin/language  (name, status, icon[file])
export async function addLanguage({ name, status, iconFile }, { signal } = {}) {
  const fd = new FormData();
  fd.set("name", name);
  fd.set("status", normalizeStatus(status));
  if (iconFile instanceof File) fd.append("icon", iconFile, iconFile.name);

  const res = await apiClient.post(endpoints.base, fd, { signal });
  return res.data;
}

// PUT: /admin/language  (id + changed fields; real PUT even with file)
export async function updateLanguage(
  { id, name, status, iconFile }, // include only the fields that changed + id
  { signal } = {}
) {
  const fd = new FormData();
  fd.set("id", id);
  if (typeof name !== "undefined") fd.set("name", name);
  if (typeof status !== "undefined") fd.set("status", normalizeStatus(status));
  if (iconFile instanceof File) fd.append("icon", iconFile, iconFile.name);

  const res = await apiClient.put(endpoints.base, fd, { signal });
  return res.data;
}

// DELETE: /admin/language  (JSON body { id })
export async function deleteLanguage({ id }, { signal } = {}) {
  const res = await apiClient.delete(endpoints.base, { signal, data: { id } });
  return res.data;
}
